<div class="row row-cols-1 row-cols-md-3 g-md-3">
  <div class="col mt-0" *ngFor="let item of offerItems$ | async">
    <div class="offer-card cursor-pointer" [routerLink]="['/brand/details', item.offer.OfferId]">
      <div class="offer-image-wrapper">
        <img [src]="item.offer.ImageUrl | contentImage : '6'" alt="" class="offer-image" />
        <div class="company-logo-wrapper" *ngIf="item.company?.ImageUrl">
          <img [src]="item.company!.ImageUrl | contentImage : '6'" alt="{{ item.company?.DisplayName }}" class="company-logo" />
        </div>
      </div>
      <div class="product-info">
        <p class="company-name mb-0">{{ item.company?.DisplayName }}</p>
        <p class="offer-title mb-0">{{ item.offer.Content[0]?.Name }}</p>
      </div>
    </div>
  </div>
</div>
